import { render, staticRenderFns } from "./PTOPolicyList.vue?vue&type=template&id=64367dee&scoped=true&"
import script from "./PTOPolicyList.vue?vue&type=script&lang=ts&"
export * from "./PTOPolicyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64367dee",
  null
  
)

export default component.exports